import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../firebase';
import PostTemplate from '../Post/PostComponents/PostTemplate';
import PostCategories from './PostCategories';

function AuthorPosts({userId, setPostCount}) {

    const [posts, setPosts] = useState([])
    const [activeCategory, setActiveCategory] = useState("all")

    useEffect(() => {

        async function fetchPosts() {

            try {
                const postsRef = firestore.collection("recipes");

                if (activeCategory !== "all") {
                    postsRef.where("author_id", "==", userId).onSnapshot(({docs}) => {
                        const posts = docs.map(doc => {
                            return {id: doc.id, ...doc.data()}
                        })
                        setPostCount(posts.length)
                        const postsByCategory = posts.filter(post => {
                            return post.category_id === activeCategory
                        })
                        setPosts(postsByCategory)                     
                    })

                } else {
                    postsRef.where("author_id", "==", userId).onSnapshot(({docs}) => {
                        const posts = docs.map(doc => {
                            return {id: doc.id, ...doc.data()}
                        })
                        setPostCount(posts.length)
                        setPosts(posts)
                    })
                }


            } catch (error) {
                
            }

        }
        fetchPosts();

    }, [userId, activeCategory, setPostCount])

    return (
        <div>

            <PostCategories activeCategory={activeCategory} setActiveCategory={setActiveCategory} />

            <div className="row">
                {posts && posts.length ? posts.map((post, index) => {

                    const date = post && post.date.toDate()
                    const dateFormatted = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`

                    return (
                        <PostTemplate 
                            key={index}
                            title={post.title}
                            author={post.author_name}
                            postId={post.id}
                            dateFormatted={dateFormatted}
                            imageUrl={post.imageUrl}
                        />
                    )
                }) 
                : 
                <p>Ingen innlegg i denne kategorien</p>
                }
            </div>
        </div>
    )

}
export default AuthorPosts